module.exports = __webpack_public_path__ + "static/media/211231_GKC_Cam_02-mobile.a658a839.webp";